import { FundamentalMetrics } from '../../../models/FundamentalMetrics';
import { FundamentalMetricsDto } from '../../../services/dtos/fundamentalMetrics.dto';

export const mapFundamentalMetricsDtoToFundamentalMetrics = (metrics: FundamentalMetricsDto): FundamentalMetrics => ({
  displayAttributes: metrics.display_attributes,
  currency: metrics.currency,
  companyId: metrics.cs_companyid,
  cqs: metrics.cqs,
  cre: metrics.cre_1y,
  crl: metrics.credit_risk_level,
  displayName: metrics.display_name,
  modelSector: metrics.model_sector,
});
